export const debounce  = (func, delay) => {
    let timeout;
    return (...args) => {
        const context  = this;
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            return func.apply(context,args);
        }, delay)
    }
}